import React from 'react';
import '../styles/Title.css';

export const Title = ({ text }) => {
  return <h1 className="title">{text}</h1>;
};
